import { render, staticRenderFns } from "./ListaEstabelecimento.vue?vue&type=template&id=4a2ef0f3&"
import script from "./ListaEstabelecimento.vue?vue&type=script&lang=js&"
export * from "./ListaEstabelecimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports